/**
 * This is used to override slots with empty content (instead of falling back to default slot)
 */
export default {
  render: h => h(),
};
